import { Colors, Flex } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const SchedulesPageHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 12px;
  border-bottom: 1px solid ${Colors['border--muted']};
`;
